import {useContext} from 'react'

import AtomButton from '@s-ui/react-atom-button'
import {ATOM_ICON_COLORS, ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import IconAdInsert from '@adv-mt/mt-svg-icons/lib/AdInsert'

import {ptaButtonProps} from './buttonConfig.js'

const PanelPublishYourAd = () => {
  const {domain, i18n} = useContext(Context)
  const appName = domain.get('config').get('APP_NAME')
  const buttonText = i18n.t('PTA_SUBMIT')

  return (
    <>
      <h4 className="mt-FormContactSeller-ptaTitle--centered">
        {i18n.t(`CONTACT_SELLER.CONFIRMATION.PTA_${appName}`)}
      </h4>
      <AtomButton
        {...ptaButtonProps}
        aria-label={buttonText}
        href={i18n.t(`HOME_SERVICES_TRADING_${appName}_SELL_URL`)}
        leftIcon={<IconAdInsert color={ATOM_ICON_COLORS.currentColor} size={ATOM_ICON_SIZES.medium} />}
      >
        {buttonText}
      </AtomButton>
    </>
  )
}

PanelPublishYourAd.displayName = 'PanelPublishYourAd'

export default PanelPublishYourAd
